export default __webpack_public_path__ + "static/media/coming-soon-brush.d8e87460.png";